export default __webpack_public_path__ + "static/media/edit.9f790573.svg";